import React, { useEffect, useState } from "react";
import { Table } from "../../components/Table/Table";
import { admin_list } from "../redux/api/dummyJson";
import { useLocation, useNavigate } from "react-router-dom";
import { useLazySalesListViewQuery } from "../redux/api/api";

const SalesView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [list, setList] = useState([]);
  const [pagecount, setPagecount] = useState("");
  const [pageno, setPageno] = useState(1);
  const id = location?.state?.id;
  const [count, setCount] = useState();

  const [getSalesList] = useLazySalesListViewQuery();

  const salesList = (pageno) => {
    const formdata = new FormData();
    formdata.append("page", pageno);
    formdata.append("per_page", 10);
    formdata.append("row", 10);
    getSalesList({ id: id, pageno: pageno })
      .unwrap()
      .then((res) => {
        console.log("res", res);
        let temp = [];
        res?.data?.map((item, ind) => {
          let obj = { ...item };
          obj.current_page = res?.pagination_meta?.current_page;
          temp.push(obj);
        });
        setList(temp);
        // setcount(res?.pagination_meta?.total);

        setPagecount(res?.pagination_meta);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    salesList(pageno);
  }, [pageno]);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <p>{row.index + 1}</p>
            // <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>
          );
        },
      },
      {
        Header: "Property ID",
        accessor: "property_id",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              <p
                className="pointer hoverline"
                onClick={() =>
                  navigate("/property-view", {
                    state: { data: row.original },
                  })
                }
              >
                {value}
              </p>
            </div>
          );
        },
      },
      {
        Header: "Property Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              <p
                className="pointer hoverline"
                onClick={() =>
                  navigate("/property-view", {
                    state: { data: row.original },
                  })
                }
              >
                {value}
              </p>
            </div>
          );
        },
      },
      {
        Header: "Owner Name",
        accessor: "owner_name",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              <p
                className="pointer hoverline"
                onClick={() =>
                  navigate("/owner-view", {
                    state: { type: "view", id: row.original.owner_id },
                  })
                }
              >
                {value}
              </p>
            </div>
          );
        },
      },

      {
        Header: "Type",
        accessor: "property_type",
        Cell: ({ value, row }) => {
          return <p>{value == 1 ? "Rooms" : "Individual"}</p>;
        },
      },
      {
        Header: "City",
        accessor: "city_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
    ],
    []
  );
  console.log("pagecount", pageno, pagecount);
  return (
    <div className="dashRightView home_section">
      <Table
        columns={columns}
        data={list}
        setPageno={setPageno}
        pagecount={pagecount}
        show={true}
      />
    </div>
  );
};

export default SalesView;
